import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../styles/Mission.css';
import mdImage from '../assets/mdimg.jpg';
const Mission = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div className="mission-container">
      <div className="mission-row">
        <div className="mission-box mission-vision" data-aos="fade-right">
          <h2>MISSION</h2>
          <p>
            Guided by a decade of expertise, our mission is to deliver cutting-edge power system solutions with precision and integrity. We are dedicated to enhancing energy reliability and efficiency through comprehensive testing, meticulous commissioning, robust distribution, and proactive maintenance. As we grow and diversify, we remain committed to pushing the boundaries of what's possible in the energy sector, ensuring the highest standards of quality and sustainability.
          </p>
        </div>
        <div className="mission-box mission-values" data-aos="fade-left">
          <h2>VISION</h2>
          <p>
            To be the vanguard of innovation and excellence in power systems, leading the way in testing, commissioning, distribution, and maintenance. Our vision is to empower industries and communities with unparalleled energy solutions, fostering a sustainable and resilient future as we expand into new horizons.
          </p>
        </div>
      </div>

     <div className="md-card-gradient" data-aos="fade-up">
  <div className="md-card">
    <img src={mdImage} alt="Managing Director" />
    <div className="md-card-text">
      <h2>SURESH RAGHUNATHAN</h2>
      <p>
        "With a great ambition and the vision along with the expertise and skill sets, we started our business that powering up the future and maintaining balance between profitability and customer satisfaction. We are committed to our customers and partners to deliver the most efficient, reliable and cost-effective services. At Acume, we take the opportunity to address the environmental and social aspects at utmost priority and show the true spirit of corporate social responsibility. I express gratitude to all the members of management committee, managers and employees for their relentless effort to take the Acume ahead."
      </p>
      <span className="md-left md-bottom">Managing Director</span>
    </div>
  </div>
</div>

    </div>
  );
};

export default Mission;
